import React, { useState, useEffect } from "react";
import Gigantic from "../headers/Gigantic";
const Features = () => {
  const firstObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const featureIcon1 = entry.target.querySelector(".features-item1 .fa");
      const featureHeader1 = entry.target.querySelector(".features-item1 h3");
      const featureParagraph1 = entry.target.querySelector(".features-item1 p");
      
      if (entry.isIntersecting) {
        featureIcon1.classList.add("feature-anim1-1");
        featureHeader1.classList.add("feature-anim1-2");
        featureParagraph1.classList.add("feature-anim1-3");
      
        return;
      }

      featureIcon1.classList.remove("feature-anim1-1");
      featureHeader1.classList.remove("feature-anim1-2");
      featureParagraph1.classList.remove("feature-anim1-3");
      
    });
  });

  const secondObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const featureIcon2 = entry.target.querySelector(".features-item2 .fa");
      const featureHeader2 = entry.target.querySelector(".features-item2 h3");
      const featureParagraph2 = entry.target.querySelector(".features-item2 p");

      if (entry.isIntersecting) {
        featureIcon2.classList.add("feature-anim1-1");
        featureHeader2.classList.add("feature-anim1-2");
        featureParagraph2.classList.add("feature-anim1-3");
        return;
      }

      
      featureIcon2.classList.remove("feature-anim1-1");
      featureHeader2.classList.remove("feature-anim1-2");
      featureParagraph2.classList.remove("feature-anim1-3");
    });
  });

    const thirdObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const featureIcon3 = entry.target.querySelector(".features-item3 .fa");
        const featureHeader3 = entry.target.querySelector(".features-item3 h3");
        const featureParagraph3 =
          entry.target.querySelector(".features-item3 p");

        if (entry.isIntersecting) {
          featureIcon3.classList.add("feature-anim1-1");
          featureHeader3.classList.add("feature-anim1-2");
          featureParagraph3.classList.add("feature-anim1-3");
          return;
        }

        featureIcon3.classList.remove("feature-anim1-1");
        featureHeader3.classList.remove("feature-anim1-2");
        featureParagraph3.classList.remove("feature-anim1-3");
      });
    });

  useEffect(() => {
    firstObserver.observe(document.querySelector(".features-item1"));
    secondObserver.observe(document.querySelector(".features-item2"));
    thirdObserver.observe(document.querySelector(".features-item3"));
  }, []);

  return (
    // <!-- Highlights -->

    <div className="container">
      <div className="features-container">
        <Gigantic headerTitle="Our Features" />
        <div className="features">
          <div className="features-item1">
            <i className="fa fa-shopping-cart"></i>
            <div className="inner">
              <h3>Sales</h3>
              <p>
                We connect you with sellers of different kind of products, in
                order to buy on credit, and then pay later in your salary.
              </p>
            </div>
          </div>
          <div className="features-item2">
            <i className="fa fa-wrench"></i>
            <div className="inner">
              <h3>Services</h3>
              <p>
                We connect you with nearby service renderers, both
                individuals/companies such as health, mecharnical, electrical
                and others.
              </p>
            </div>
          </div>
          <div className="features-item3">
            <i className="fa fa-thumbs-up"></i>
            <div className="inner">
              <h3>Affordability</h3>
              <p>
                We are also at 0% interest rate; we do not put any interest on
                sold goods or rendered services to our customers.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Features;
